import styled from 'styled-components'

import { Alert } from 'src/components/Ant'

const WrapAlert = styled(Alert)`
  margin-top: 12px;
`

export { WrapAlert }
